import { RootState } from '@/app/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectBestsellers = (state: RootState) => state.bestsellers

export const bestsellersSelector = createSelector(selectBestsellers, (state) => state)
